import React from 'react';
import { CalendarSchedule } from '@saleshandy/icons';

import { accessibleOnClick } from '../../../utils/accessible-on-click';

type IProps = {
  onToggleDateTimePicker: VoidFunction;
};

const ScheduleReplyModalFooter: React.FC<IProps> = ({
  onToggleDateTimePicker,
}) => (
  <div
    className="schedule-reply-modal--footer"
    {...accessibleOnClick(onToggleDateTimePicker)}
  >
    <div className="icon-wrapper">
      <CalendarSchedule />
    </div>
    <p>Pick date & time</p>
  </div>
);

export default ScheduleReplyModalFooter;
